import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guid: null,
  title: null,
};

export const selectedProjectDashboardSlice = createSlice({
  name: "selectedProjectDashboard",
  initialState,
  reducers: {
    setSelectedProjectDashboard: (state, action) => {
      state.guid = action.payload.guid;
      state.title = action.payload.title;
    },
  },
});

export const { setSelectedProjectDashboard } =
  selectedProjectDashboardSlice.actions;

export const selectedProjectDashboardReducer =
  selectedProjectDashboardSlice.reducer;
